import { invitationReturnPath } from "@lib/teamInvitations";
import { Logo } from "@client/components/logo";
import { Page } from "@client/components/utils/Page";
import { Card, CardContent } from "@sfc/ui";
import { trpc } from "@client/trpc";
import { WelcomeLanding } from "./WelcomeLanding";
import { LoginPanel } from "./LoginButton";

export default function Login() {
  const isInvitation = invitationReturnPath(window.location.pathname) !== "/";
  const urlSearchParams = new URLSearchParams(window.location.search);
  const params = Object.fromEntries(urlSearchParams.entries());

  const { data: welcomeEnabled, isPending } =
    trpc.getLoggedOutLandingEnabled.useQuery(undefined, {
      staleTime: 60_000,
      retry: false,
      refetchOnWindowFocus: false,
    });

  // Resolve the layout before mounting the form so a late flag response
  // cannot discard an email the visitor has already started typing.
  if (isPending)
    return (
      <Page>
        <p role="status" className="text-center text-sm text-muted-foreground">
          Loading sign-in…
        </p>
      </Page>
    );

  if (welcomeEnabled) return <WelcomeLanding error={params.error} />;

  return (
    <Page className="flex items-center justify-center">
      <div className="mx-auto flex w-full max-w-sm flex-col gap-6">
        <div className="flex flex-col items-center gap-3 text-center">
          <Logo />
          <div className="flex flex-col gap-1">
            <h1 className="text-2xl font-bold">
              {isInvitation
                ? "You’re invited to a team"
                : "Welcome to S-Process"}
            </h1>
            <p className="text-sm text-muted-foreground">
              {isInvitation
                ? "Sign in or create an account with the email that was invited. You’ll review the invitation before joining."
                : "Sign in to your workspace"}
            </p>
          </div>
        </div>

        <Card>
          <CardContent>
            <LoginPanel />
          </CardContent>
        </Card>

        {params.error && (
          <div className="text-center text-sm text-red-500">
            Error: {params.error}
          </div>
        )}
      </div>
    </Page>
  );
}
